// FitClutch — funil web — textos em francês
export default {
  'ageSelect.titleLine1': 'Créez votre',
  'ageSelect.titleHighlight': 'Programme d’Entraînement Personnalisé',
  'ageSelect.poweredBy': 'Propulsé par l’IA de FitClutch',
  'ageSelect.subtitle': 'Choisissez votre tranche d’âge pour commencer',
  'ageSelect.duration': 'Questionnaire de 3 minutes',
  'ageSelect.ageLabel': 'Âge : {range}',
  'ageSelect.footnote': 'En continuant, vous acceptez nos {terms} et notre {privacy}.',
  'ageSelect.termsLink': 'Conditions d’Utilisation',
  'ageSelect.privacyLink': 'Politique de Confidentialité',

  'gender.title': 'Quel est votre genre ?',
  'gender.subtitle': 'Nous utilisons cela uniquement pour personnaliser votre programme',
  'gender.male': 'Homme',
  'gender.female': 'Femme',
  'gender.other': 'Préfère ne pas dire',

  'socialProof.genderWomen': 'femmes',
  'socialProof.genderMen': 'hommes',
  'socialProof.genderPeople': 'personnes',
  'socialProof.decade20': 'la vingtaine',
  'socialProof.decade30': 'la trentaine',
  'socialProof.decade40': 'la quarantaine',
  'socialProof.decade50': 'la cinquantaine ou plus',
  'socialProof.headlineBig': 'Plus de {users} {gender}',
  'socialProof.subcopy': 'dans {decade} font déjà confiance à FitClutch pour <hl>atteindre leurs objectifs, selon leur niveau et l’équipement disponible</hl>. S’adaptant au fil de votre progression.',
  'socialProof.subcopyNoDecade': 'font déjà confiance à FitClutch pour <hl>atteindre leurs objectifs, selon leur niveau et l’équipement disponible</hl>. S’adaptant au fil de votre progression.',
  'socialProof.downloadsLabel': 'Téléchargements',
  'socialProof.cta': 'Continuer',

  'goal.question': 'Quel est votre principal objectif fitness ?',
  'goal.option_hipertrofia': 'Prendre du muscle',
  'goal.option_emagrecer': 'Perdre du poids',
  'goal.option_forca': 'Devenir plus fort',
  'goal.option_condicionamento': 'Améliorer la forme générale',
  'goal.feedbackLead': 'Parfait :',
  'goal.feedback_hipertrofia': 'des séances de force personnalisées, avec une forme guidée en vidéo à chaque répétition.',
  'goal.feedback_emagrecer': 'un programme pensé pour garder votre métabolisme actif.',
  'goal.feedback_forca': 'une progression de charge sécurisée pour devenir vraiment plus fort.',
  'goal.feedback_condicionamento': 'des séances équilibrées pour améliorer endurance, mobilité et énergie.',

  'bodyShape.question': 'Lequel décrit le mieux votre corps aujourd’hui ?',
  'bodyShape.option_magro_male': 'Mince',
  'bodyShape.option_magro_female': 'Mince',
  'bodyShape.option_magro_neutral': 'Corps mince',
  'bodyShape.option_cheio_male': 'Plus enveloppé',
  'bodyShape.option_cheio_female': 'Plus enveloppée',
  'bodyShape.option_cheio_neutral': 'Corps plus enveloppé',
  'bodyShape.option_atletico_male': 'Athlétique',
  'bodyShape.option_atletico_female': 'Athlétique',
  'bodyShape.option_atletico_neutral': 'Corps athlétique',
  'bodyShape.option_definido_male': 'Tonique',
  'bodyShape.option_definido_female': 'Tonique',
  'bodyShape.option_definido_neutral': 'Corps tonique',
  'bodyShape.option_medio_male': 'Moyen',
  'bodyShape.option_medio_female': 'Moyenne',
  'bodyShape.option_medio_neutral': 'Corps moyen',

  'bodyGoal.question': 'Quel corps voulez-vous obtenir ?',
  'bodyGoal.option_definido_male': 'Sec et tonique',
  'bodyGoal.option_definido_female': 'Sèche et tonique',
  'bodyGoal.option_definido_neutral': 'Corps sec et tonique',
  'bodyGoal.option_atletico_male': 'Athlétique et musclé',
  'bodyGoal.option_atletico_female': 'Athlétique et en forme',
  'bodyGoal.option_atletico_neutral': 'Corps athlétique et musclé',
  'bodyGoal.option_magro_male': 'Mince et léger',
  'bodyGoal.option_magro_female': 'Mince et légère',
  'bodyGoal.option_magro_neutral': 'Corps mince et léger',
  'bodyGoal.option_curvilineo_male': 'Fort et robuste',
  'bodyGoal.option_curvilineo_female': 'Forte et avec des courbes',
  'bodyGoal.option_curvilineo_neutral': 'Corps fort et défini',

  'lastBest.question': 'À quand remonte la dernière fois où vous vous êtes senti(e) au mieux physiquement ?',
  'lastBest.option_agora': 'En ce moment',
  'lastBest.option_menos_1_ano': 'Il y a moins d’un an',
  'lastBest.option_1_3_anos': 'Il y a 1 à 3 ans',
  'lastBest.option_mais_3_anos': 'Il y a plus de 3 ans',
  'lastBest.option_nunca': 'Jamais',

  'weightTrend.question': 'Comment votre poids évolue-t-il généralement ?',
  'weightTrend.option_estavel': 'Plutôt stable',
  'weightTrend.option_varia': 'Monte et descend selon mes habitudes',
  'weightTrend.option_subindo': 'Augmente régulièrement',
  'weightTrend.option_caindo': 'Diminue régulièrement',
  'weightTrend.option_nao_sei': 'Je ne sais pas',

  'transformPromo.headline': 'Votre objectif : {target}. On vous montre exactement comment y arriver.',
  'transformPromo.subcopyLead': 'Entraînez-vous en toute sécurité. FitClutch propose des',
  'transformPromo.subcopyHighlight1': 'démos vidéo expertes',
  'transformPromo.subcopyMid': 'pour chaque mouvement, pour vous aider à avoir la bonne forme et',
  'transformPromo.subcopyHighlight2': 'éviter les blessures',
  'transformPromo.cta': 'Continuer',

  'pushUps.question': 'Quel est votre maximum de pompes d’affilée ?',
  'pushUps.option_nenhuma': 'Aucune pour l’instant',
  'pushUps.option_1_5': '1 à 5',
  'pushUps.option_6_15': '6 à 15',
  'pushUps.option_16_30': '16 à 30',
  'pushUps.option_30_mais': 'Plus de 30',

  'squats.question': 'Combien de squats enchaînez-vous sans vous arrêter ?',
  'squats.option_nenhuma': 'Aucun pour l’instant',
  'squats.option_1_10': '1 à 10',
  'squats.option_11_25': '11 à 25',
  'squats.option_26_50': '26 à 50',
  'squats.option_50_mais': 'Plus de 50',

  'flexibility.question': 'Quel est votre niveau de souplesse ?',
  'flexibility.option_nao_alcanco': 'Je n’arrive pas à toucher mes pieds',
  'flexibility.option_quase': 'Je touche presque mes pieds',
  'flexibility.option_facil': 'Je touche mes pieds facilement',
  'flexibility.option_muito_flexivel': 'Très souple (grand écart, étirements profonds)',
  'flexibility.option_nao_sei': 'Je ne sais pas',

  'progressPromo.headline': 'Votre point de départ est fixé. Maintenant, regardons-le évoluer.',
  'progressPromo.subcopyLead': 'Chaque séance est',
  'progressPromo.subcopyHighlight': 'enregistrée automatiquement',
  'progressPromo.subcopyTail': '— des statistiques en temps réel pour vous motiver.',
  'progressPromo.cta': 'Continuer',

  'focusArea.question': 'Quelles sont vos zones ciblées ?',
  'focusArea.subtitle': 'Choisissez une zone précise ou "Corps entier".',
  'focusArea.option_superior': 'Haut du corps',
  'focusArea.option_core': 'Core / Abdos',
  'focusArea.option_inferior': 'Bas du corps',
  'focusArea.option_corpo_inteiro': 'Corps entier',
  'focusArea.cta': 'Continuer',

  'injuries.question': 'Une zone mérite-t-elle plus d’attention ?',
  'injuries.subtitle': 'Nous adapterons vos exercices pour protéger ces zones.',
  'injuries.option_ombros': 'Épaules',
  'injuries.option_joelhos': 'Genoux',
  'injuries.option_costas': 'Dos',
  'injuries.option_nenhuma': 'Aucune',
  'injuries.disclaimer': 'Ajustements préventifs — ne remplacent pas un avis médical.',
  'injuries.cta': 'Continuer',

  'workoutDuration.question': 'Quelle est ta durée d’entraînement idéale ?',
  'workoutDuration.option_rapido': 'Rapide',
  'workoutDuration.option_rapido_subtitle': '3 exercices',
  'workoutDuration.option_rapido_badge': "Jusqu'à 20 min",
  'workoutDuration.option_curto': 'Court',
  'workoutDuration.option_curto_subtitle': '4-6 exercices',
  'workoutDuration.option_curto_badge': '20-40 min',
  'workoutDuration.option_medio': 'Moyen',
  'workoutDuration.option_medio_subtitle': '5-7 exercices',
  'workoutDuration.option_medio_badge': '40-60 min',
  'workoutDuration.option_longo': 'Long',
  'workoutDuration.option_longo_subtitle': '8-10 exercices',
  'workoutDuration.option_longo_badge': '60+ min',

  'trainingSummaryPromo.headline': '{days}, séances de {duration} — en préparation.',
  'trainingSummaryPromo.subcopyLead': 'Tout droit sortis de notre',
  'trainingSummaryPromo.subcopyHighlight': 'bibliothèque d’entraînements',
  'trainingSummaryPromo.subcopyTail': ', il y en a toujours un prêt pour vous.',
  'trainingSummaryPromo.cta': 'Continuer',
  'trainingSummaryPromo.days_2': '1 à 2x par semaine',
  'trainingSummaryPromo.days_4': '3 à 4x par semaine',
  'trainingSummaryPromo.days_6': '5 à 6x par semaine',
  'trainingSummaryPromo.days_7': 'Tous les jours',

  'workSchedule.question': 'À quoi ressemblent vos horaires de travail ?',
  'workSchedule.option_fixo': 'Horaires de bureau',
  'workSchedule.option_noturno': 'Travail de nuit',
  'workSchedule.option_flexivel': 'Horaires flexibles',
  'workSchedule.option_parado': 'Je ne travaille pas',

  'dailyActivity.question': 'Quel est votre niveau d’activité au quotidien ?',
  'dailyActivity.option_sentado': 'Principalement assis',
  'dailyActivity.option_ativo': 'Debout ou en mouvement',
  'dailyActivity.option_misto': 'Un peu des deux',
  'dailyActivity.option_nao_sei': 'Je ne sais pas',

  'sleepHours.question': 'Combien d’heures dormez-vous habituellement ?',
  'sleepHours.option_menos_5': 'Moins de 5 heures',
  'sleepHours.option_5_6': '5-6 heures',
  'sleepHours.option_7_8': '7-8 heures',
  'sleepHours.option_mais_8': 'Plus de 8 heures',

  'waterIntake.question': 'Combien de verres d’eau buvez-vous par jour ?',
  'waterIntake.subtitle': 'Touchez le chiffre le plus proche de votre routine.',
  'waterIntake.cta': 'Continuer',

  'profileSummary.headline': 'Voici votre profil',
  'profileSummary.imcLabel': 'IMC - {imc}',
  'profileSummary.imcAbaixo': 'Insuffisant',
  'profileSummary.imcNormal': 'Normal',
  'profileSummary.imcAcima': 'Élevé',
  'profileSummary.imcObeso': 'Obèse',
  'profileSummary.bodyTypeLabel': 'Type de corps',
  'profileSummary.bodyType_ectomorfo': 'Ectomorphe',
  'profileSummary.bodyType_mesomorfo': 'Mésomorphe',
  'profileSummary.bodyType_endomorfo': 'Endomorphe',
  'profileSummary.lifestyleLabel': 'Mode de vie',
  'profileSummary.lifestyle_sedentario': 'Sédentaire',
  'profileSummary.lifestyle_ativo': 'Actif',
  'profileSummary.lifestyle_equilibrado': 'Équilibré',
  'profileSummary.conditioningLabel': 'Niveau de forme',
  'profileSummary.conditioning_iniciante': 'Basique',
  'profileSummary.conditioning_intermediario': 'Intermédiaire',
  'profileSummary.conditioning_avancado': 'Avancé',
  'profileSummary.conditioning_especialista': 'Expert',
  'profileSummary.metabolismLabel': 'Métabolisme',
  'profileSummary.metabolism_lento': 'Lent, prend du poids facilement',
  'profileSummary.metabolism_acelerado': 'Rapide, perd du poids facilement',
  'profileSummary.metabolism_equilibrado': 'Équilibré',
  'profileSummary.metabolism_variavel': 'Variable, selon les habitudes',
  'profileSummary.cta': 'Continuer',

  'barriers.question': 'Qu’est-ce qui vous a empêché de vous mettre en forme avant ?',
  'barriers.option_motivacao': 'Manque de motivation',
  'barriers.option_sem_plano': 'Pas de plan structuré',
  'barriers.option_tempo': 'Manque de temps',
  'barriers.option_lesoes': 'Blessures physiques',
  'barriers.option_outro': 'Autres raisons',

  'consistencyChart.headline': 'FitClutch vous aide à rester constant !',
  'consistencyChart.subcopyLead': 'Votre plan personnalisé a tout ce qu’il faut pour',
  'consistencyChart.subcopyHighlight1': 'garder votre motivation au top',
  'consistencyChart.subcopyMid': 'et',
  'consistencyChart.subcopyHighlight2': 'atteindre le physique que vous voulez',
  'consistencyChart.chartTitle': 'Votre évolution',
  'consistencyChart.nowLabel': 'Maintenant',
  'consistencyChart.withLabel': 'Avec FitClutch',
  'consistencyChart.withoutLabel': 'Sans FitClutch',
  'consistencyChart.disclaimer': 'Avertissement : les exemples sont illustratifs. Rester constant dans l’entraînement et l’alimentation est ce qui mène vraiment aux résultats.',
  'consistencyChart.cta': 'Continuer',

  'progressLoader.headline': 'Création de votre plan d’entraînement personnel',
  'progressLoader.item_bodyType': 'Adaptation à votre type de corps et votre routine',
  'progressLoader.item_fitnessLevel': 'Évaluation de votre niveau de forme',
  'progressLoader.item_plan': 'Construction de votre plan personnalisé',
  'progressLoader.testimonial1_title': 'Ça a changé ma routine',
  'progressLoader.testimonial1_body': 'Enfin un plan qui s’adapte vraiment à ma semaine. Facile à suivre et les séances ont du sens.',
  'progressLoader.testimonial1_author': 'Renata A.',
  'progressLoader.testimonial2_title': 'Des résultats concrets',
  'progressLoader.testimonial2_body': 'En quelques semaines, j’ai déjà senti la différence en énergie et en force. Le plan s’adapte à moi.',
  'progressLoader.testimonial2_author': 'Juliana M.',
  'progressLoader.testimonial3_title': 'Une routine que je tiens vraiment',
  'progressLoader.testimonial3_body': 'Je n’avais jamais réussi à tenir une routine avant FitClutch. Maintenant ça fait partie de ma journée.',
  'progressLoader.testimonial3_author': 'Carla S.',
  'progressLoader.testimonial4_title': 'Ça vaut vraiment le coup',
  'progressLoader.testimonial4_body': 'Simple, direct, et pensé pour mon corps et mon emploi du temps.',
  'progressLoader.testimonial4_author': 'Fernanda O.',

  'emailCapture.headlineLead': 'Entrez votre e-mail pour recevoir votre',
  'emailCapture.headlineHighlight': 'Plan d’entraînement personnalisé',
  'emailCapture.placeholder': 'votremail@exemple.com',
  'emailCapture.cta': 'Continuer',
  'emailCapture.privacyLead': 'Nous respectons votre vie privée et protégeons vos données personnelles, conformément à notre',
  'emailCapture.privacyLink': 'Politique de confidentialité',
};
